$(document).ready(function () {
  
  function checkAddToCartButton() {

    if ($('button.add-to-cart').length) {
      var addToCartBtn = $('button.add-to-cart');
      var addToCartText = addToCartBtn.find('span').text();
  
      if (addToCartText.toLowerCase().indexOf("sold out") >= 0) {
        addToCartBtn.attr('disabled', 'disabled');
        $('.bold_options').hide();
      }
    }

  }

  setTimeout(checkAddToCartButton, 1000)
  
  // Disable header search form submit
  $('header .searchform').submit(false);
  $('header .searchform')[0].submit = function () {};
});